import React, { useContext } from 'react';
import { Persona, Link, classNamesFunction, PersonaSize } from '@fluentui/react';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { IDefaultMeControlStyles, IDefaultMeControlProps } from './DefaultMeControl.types';
import { defaultMeControlPanelStyles } from './DefaultMeControl.styles';

const getClassNames = classNamesFunction<Record<string, unknown>, IDefaultMeControlStyles>();

export const DefaultMeControlPanel: React.FC<IDefaultMeControlProps> = props => {
  const context = useContext(SuiteHeaderContext);
  const { name, upn, imageUrl } = context.userData;
  const { leaveNewExp } = context.localizationMap;
  const { onLeavePreview, onSignOut, viewAccountLink } = props;
  const accountUrl = new URL(viewAccountLink);
  accountUrl.searchParams.set('upn', upn);

  const classNames = getClassNames(defaultMeControlPanelStyles);

  return (
    <>
      <div className={classNames.section}>
        <Persona
          imageUrl={imageUrl}
          imageAlt={name}
          text={name ? name : upn}
          secondaryText={upn}
          size={PersonaSize.size48}
        />
      </div>
      <div className={classNames.section}>
        <Link className={classNames.link} href={accountUrl.toString()} target="_blank">
          {'View my account'}
        </Link>
      </div>
      {onLeavePreview && (
        <div className={classNames.section}>
          <Link className={classNames.link} onClick={onLeavePreview}>
            {leaveNewExp}
          </Link>
        </div>
      )}
      <div className={classNames.section}>
        <Link className={classNames.link} onClick={onSignOut}>
          {'Sign out'}
        </Link>
      </div>
    </>
  );
};
